let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6jQjt")).then(() => parcelRequire('gSCsn'));